import { render } from "./create-template-button.vue?vue&type=template&id=8e18a606"
import script from "./create-template-button.vue?vue&type=script&setup=true&lang=js"
export * from "./create-template-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/whatsapp/pages/templates/list/components/create-template-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e18a606"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e18a606', __exports__)) {
    console.log('reload')
    api.reload('8e18a606', __exports__)
  }
  
  module.hot.accept("./create-template-button.vue?vue&type=template&id=8e18a606", () => {
    console.log('re-render')
    api.rerender('8e18a606', render)
  })

}


export default __exports__